export default __webpack_public_path__ + "static/media/Order-Cancel.bb6283c5.jpg";